/**
 * O `eventID` do `Lead` do pixel do Meta no cadastro.
 *
 * O `Lead` sai do navegador (tag do `GTM-KBF6J9QS` no `cadastro_criado`) e, desde o changeset 649,
 * também do servidor (`telegram-bot`, marco `SIGNUP`), porque bloqueador de anúncio e restrição de
 * cookie derrubam parte do primeiro sem deixar rastro. O Meta só conta os dois como UM evento se
 * nome e `eventID` baterem — e o id nasce aqui: vai no corpo do cadastro (o platform-api grava em
 * `platform_user.meta_lead_event_id`, e o servidor manda com ele) e no `dataLayer` junto do
 * `cadastro_criado` (a tag do `Lead` o passa ao `fbq('track', 'Lead', {}, { eventID })`).
 *
 * Não identifica ninguém: é aleatório, um por tentativa de cadastro.
 */

/** A chave do `dataLayer` que a tag do `Lead` lê, pela variável `vibx_lead_event_id`. */
export const META_LEAD_EVENT_ID_KEY = 'vibx_lead_event_id';

/** Um UUID v4. Sem `crypto.randomUUID` (navegador antigo, contexto não seguro), um v4 à mão. */
export const newMetaLeadEventId = (): string => {
  const c = typeof crypto === 'undefined' ? undefined : crypto;
  if (c?.randomUUID) return c.randomUUID();

  const bytes = new Uint8Array(16);
  if (c?.getRandomValues) c.getRandomValues(bytes);
  else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join(
    '',
  );
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16,
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
